import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/tokens.css';
import './styles/components.css';
import './styles/screens.css';
import './styles/round.css';
import './styles/map.css';
import './styles/howto.css';
import './styles/studio.css';
import { SocketProvider } from './state/SocketProvider';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SocketProvider>
      <App />
    </SocketProvider>
  </StrictMode>,
);
